import axios from "axios";
// without JWT token including in header
// Create a separate Axios instance for public requests
const publicAxios = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json"
  }
});

export default publicAxios;
